import {
  FaEdit,
  FaPaintBrush,
  FaSearch,
  FaShoppingCart,
} from "@onemind-services-llc/react-icons-ng/fa";
import HeroBg from "public/marketplace-apps/hero/Hero-section-wordpress.png";

export const WORDPRESS_CONSTANTS = {
  HERO: {
    title: "OneMind Services — WordPress (One-Click Application) ",
    desc: "Launch WordPress — the world’s most popular open-source CMS for blogs, websites, and online stores — with a single click.",
    button: {
      label: "Try Now",
      link: "contact-us",
    },
    image: HeroBg,
  },
  INTRO: {
    title: "General Information",
    text: "WordPress is the world’s most popular open-source content management system (CMS), powering over 40% of websites globally. It provides a flexible platform for blogs, portfolios, business websites, and eCommerce via plugins like WooCommerce, all with a user-friendly interface and customizable themes. ",
  },
  WHY_ONEMIND: {
    title: "Deploy Effortlessly with OneMind Ease ",
    desc: [
      {
        highlight: "One-Click Installation",
        text: " One-Click Installation : Launch a fully configured and secure WordPress instance in minutes—no need to install or manage dependencies. ",
      },
      {
        highlight: "Global Reach",
        text: " Global Reach : Deploy in any of our multiple data-center regions to keep latency low and performance high. ",
      },
      {
        highlight: "Pre‑Configured Setup",
        text: " Pre‑Configured Setup : Includes WordPress core, MySQL/MariaDB backend, Apache/Nginx, and default credentials.  ",
      },
    ],
    marginTop: 0,
    btnText: "Start Now",
  },
  GET_STARTED: {
    title: "Access & Administration ",
    desc: [
      {
        text: "Once deployed, you’ll receive in your console:",
      },
      {
        text: " Username :",
        highlight: "admin",
      },
      {
        text: " Password :",
        highlight: "<generated-password>",
      },
    ],
    connection: {
      text: "Access the WordPress admin panel at: ",
      command: "http://<YOUR_INSTANCE_IP>/wp-admin ",
    },
    installation: {
      heading: "Installation Location -",
      text: "The WordPress files are located in the directory ",
      location: " /var/www/html/",
    },
    ports: {
      heading: "Ports Used ",
      text: "Application, besides standard Ubuntu Ports (53/22), uses: ",
      list: ["80 (HTTP)", "443 (HTTPS)"],
    },
    note: "Note : Find all web files at /var/www/html/ and update wp-config.php for DB settings or custom constants. ",
  },
  FEATURES: {
    items: [
      {
        icon: FaEdit,
        title: "Easy Content Management",
        text: "User-friendly interface for publishing pages, posts, and media.",
      },
      {
        icon: FaPaintBrush,
        title: "Themes & Plugins",
        text: "Thousands of free and premium themes and plugins to extend design and functionality.",
      },
      {
        icon: FaSearch,
        title: "SEO Friendly",
        text: "Clean URL structure, metadata, and integrations with SEO plugins.",
      },
      {
        icon: FaShoppingCart,
        title: "eCommerce Ready",
        text: "Supports WooCommerce for building scalable online stores.",
      },
    ],
  },
  BENEFITS: {
    title: "Resilience & Scaling ",
    options: [
      {
        label: "Backups & Snapshots",
        text: "Use OneMind’s snapshot feature or standard WordPress backup plugins (e.g., UpdraftPlus). ",
      },
      {
        label: "Security Out of the Box",
        text: "Pre-hardened setup with firewall rules, admin access control, and HTTPS support. ",
      },
      {
        label: "Scalable Architecture",
        text: "Easily scale compute, storage, and database resources; optionally use CDN and object caching for performance. ",
      },
    ],
  },
  SUPPORT: {
    docsText: "Wordpress Official Docs",
    docsLink: "https://wordpress.org/documentation/",
  },
};
